import {
  PublicClientApplication,
  EventType,
  EndSessionRequest,
} from "@azure/msal-browser";
import { msalConfig } from "../authConfig";
import type { AuthClient } from "./auth.types";

export const pca = new PublicClientApplication(msalConfig);

let interactionInProgress = false;

pca.addEventCallback((event) => {
  switch (event.eventType) {
    case EventType.LOGIN_START:
    case EventType.ACQUIRE_TOKEN_START:
    case EventType.LOGOUT_START:
    case EventType.SSO_SILENT_START:
    case EventType.HANDLE_REDIRECT_START:
      interactionInProgress = true;
      break;

    case EventType.LOGIN_SUCCESS:
    case EventType.LOGIN_FAILURE:
    case EventType.ACQUIRE_TOKEN_SUCCESS:
    case EventType.ACQUIRE_TOKEN_FAILURE:
    case EventType.LOGOUT_SUCCESS:
    case EventType.LOGOUT_FAILURE:
    case EventType.SSO_SILENT_SUCCESS:
    case EventType.SSO_SILENT_FAILURE:
    case EventType.HANDLE_REDIRECT_END:
      interactionInProgress = false;
      break;
  }
});

export const msalAuthClient: AuthClient = {
  async loginRedirect(args) {
    await pca.loginRedirect(args);
  },
  async acquireTokenSilent(args) {
    const resp = await pca.acquireTokenSilent(args);
    return { accessToken: resp.accessToken };
  },
  getAccounts() {
    return pca.getAllAccounts();
  },
  getInProgress() {
    return interactionInProgress ? "login" : "none";
  },
  isAuthenticated() {
    return pca.getAllAccounts().length > 0;
  },
  async logoutRedirect(args: EndSessionRequest) {
    await pca.logoutRedirect(args);
  },
  async handleRedirect() {
    await pca.handleRedirectPromise();
  },
};
